import { useNavigate } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";
import { returnPolicyData } from "../data/profile/returnPolicy";

export default function ReturnPolicySection() {
    const navigate=useNavigate();
  return (
    <div className="bg-white py-5 px-4 md:px-8 xl:px-10 xl:py-10 text-[#333]">
        <div className="flex flex-row space-x-2 items-center justify-start mb-5" onClick={()=>navigate(-1)}>
            <MdKeyboardBackspace className="text-lg md:text-xl xl:text-2xl" />
            <p className="text-lg md:text-xl xl:text-2xl font-medium text-center pb-2">Return Policy</p>
        </div>
      
      {returnPolicyData.map((section, index) => (
        <div key={index}>
          <h2 className="text-sm md:text-base xl:text-lg font-semibold text-[#A63F40]">{section.title}</h2>
          <ul className="list-disc list-inside text-xs md:text-sm xl:text-base space-y-1">
            {section.points.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
